export default __webpack_public_path__ + "static/Денежный поток 303+404_5-5bb516cffa11939ac0e7cb24a3ef6061.png";